import { SubscriptionPack } from "@/types/models/subscriptionTypes";

export const subscriptionTypeMapper = (pack: SubscriptionPack) => {
    return {
        ...pack,
        specializations: pack.specializations?.map(spec => {
            return { id: spec.id, value: spec.title };
        }),
        medicalServiceTypes: (pack.medical_service_types || pack.medicalServiceTypes)?.map(type => {
            return { id: type.id, value: type.title };
        })
    }
};